import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Typography } from '@tempmee/react';
import { OutlineRefreshIcon } from '@tempmee/react-icons';
import { ListPageHeader } from '../../commonComponents/ListPageHeader';
import { fetchReferrals } from '../../../actions/referralAction';
import { createLoadingSelector } from '../../../apis/selectors';
import { Table } from '../../commonComponents/Table/Table';
import { referralColumns, referralRowColorStyles } from '../../commonComponents/jobs-column';
import { CustomHeader } from './CustomHeader';
import { ActionComponent } from './ActionComponent';
import { handleFilterChange } from '../../commonComponents/Table/utils';

const ROWS_PER_PAGE = 15;

const actions = ['GET_REFERRAL', 'CANCEL_REFERRAL'];
const loadingSelector = createLoadingSelector(actions);

export const ReferralList = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => loadingSelector(state));
  const referrals = useSelector((state) => state.referral.referrals);
  const searchParams = useSelector((state) => state.referral.searchParams);
  const totalFiltered = useSelector((state) => state.referral.totalReferrals);
  const [filter, setFilter] = useState({
    searchText: searchParams?.searchText || '',
    payFilter: searchParams?.payFilter || 'all',
    referrerType: searchParams?.referrerType || 'all',
    page: searchParams?.page || 1,
    sortField: searchParams?.sortField || '',
    order: searchParams?.order || 'desc',
  });
  const totalPages = Math.ceil(totalFiltered / ROWS_PER_PAGE);

  const handleTableChange = (page) => {
    setFilter((prevState) => ({ ...prevState, page }));
  };

  const reloadReferrals = () => {
    dispatch(
      fetchReferrals({
        ...searchParams,
        refresh: 1,
      }),
    );
  };

  useEffect(
    () => () => {
      // cleanup
      dispatch(
        fetchReferrals({
          page: 1,
          limit: 15,
        }),
      );
    },
    [],
  );

  useEffect(() => {
    dispatch(
      fetchReferrals({
        ...filter,
      }),
    );
  }, [filter, dispatch]);

  const getUserUrl = (userId, userType) => `/user/${userType.toLowerCase()}/${userId}`;

  const getColumn = () =>
    referralColumns({
      getUserUrl,
      ActionComponent: (row) => <ActionComponent row={row} />,
    });

  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        overflowY: 'auto',
        flexDirection: 'column',
        position: 'relative',
        alignItems: 'center',
        paddingTop: 24,
      }}
    >
      <div style={{ width: '90%' }}>
        <ListPageHeader
          title="Referral"
          isLoading={isLoading}
          actions={(
            <IconButton
              aria-label="Reload referrals"
              appearance="default"
              Icon={<OutlineRefreshIcon />}
              onClick={reloadReferrals}
            />
          )}
          meta={(
            <Typography size="body_large" bold>
              Total | {new Intl.NumberFormat().format(totalFiltered)}
            </Typography>
          )}
        />
        <CustomHeader
          filter={filter}
          handleFilterChange={(type, value) => handleFilterChange(type, value, setFilter)}
        />
        <Table
          keyField="referralList.id"
          initialPage={filter.page}
          columns={getColumn()}
          data={referrals}
          noDataComponent="There are no referrals"
          isLoading={isLoading}
          totalPages={totalPages}
          showColumnsToHide={false}
          paginationPerPage={ROWS_PER_PAGE}
          paginationTotalRows={totalFiltered}
          showTotal={false}
          onPageChange={handleTableChange}
          conditionalRowStyles={referralRowColorStyles}
        />
      </div>
    </div>
  );
};
